import axios from 'axios';

const API_BASE_URL = import.meta.env.VITE_API_BASE_URL || 'http://localhost:3402';

export interface CreateTipRequest {
  toCreatorId: string;
  amount: number; // in major currency units
  currency?: string;
  message?: string;
  isAnonymous?: boolean;
  isPublic?: boolean;
}

export const tipsService = {
  async createTip(payload: CreateTipRequest): Promise<{ tipId: string; clientSecret: string } > {
    const token = localStorage.getItem('accessToken');
    const res = await axios.post(`${API_BASE_URL}/api/tips`, payload, {
      headers: { Authorization: `Bearer ${token}` },
    });
    return res.data;
  },

  async getTip(tipId: string) {
    const token = localStorage.getItem('accessToken');
    const res = await axios.get(`${API_BASE_URL}/api/tips/${tipId}`, {
      headers: { Authorization: `Bearer ${token}` },
    });
    return res.data as { tip: any };
  },

  async history(params: { type?: 'sent' | 'received'; limit?: number; offset?: number } = {}) {
    const token = localStorage.getItem('accessToken');
    const res = await axios.get(`${API_BASE_URL}/api/tips`, {
      headers: { Authorization: `Bearer ${token}` },
      params,
    });
    return res.data as { tips: any[]; pagination?: any };
  },

  async analytics(params: { from?: string; to?: string; interval?: 'day' | 'week' | 'month' } = {}) {
    const token = localStorage.getItem('accessToken');
    const res = await axios.get(`${API_BASE_URL}/api/tips/analytics`, {
      headers: { Authorization: `Bearer ${token}` },
      params,
    });
    return res.data as any;
  },

  async topTippers(params: { limit?: number; days?: number } = {}) {
    const token = localStorage.getItem('accessToken');
    const res = await axios.get(`${API_BASE_URL}/api/tips/top-tippers`, {
      headers: { Authorization: `Bearer ${token}` },
      params,
    });
    return res.data as { topTippers: Array<{ userId: string; totalAmount: number; tipCount: number }>; };
  },

  async sendThankYou(tipId: string, data: { thankYouMessage?: string; thankYouMediaUrl?: string }) {
    const token = localStorage.getItem('accessToken');
    const res = await axios.post(`${API_BASE_URL}/api/tips/${tipId}/thank-you`, data, {
      headers: { Authorization: `Bearer ${token}` },
    });
    return res.data as { message: string };
  },
};
